import AnnualSpendCard from "./AnnualSpendCard";
import AnnualUsageCard from "./AnnualUsageCard";

const Annual = ({
  setShowHowSpendCalculatedModal,
  setShowHowUsageCalculatedModal,
  setShowEditTariffModal,
}) => {
  return (
    <div className="space-y-6">
      <AnnualSpendCard
        setShowHowSpendCalculatedModal={setShowHowSpendCalculatedModal}
        showEditUsageForm={() => setShowEditTariffModal(true)}
      />

      <AnnualUsageCard
        setShowHowUsageCalculatedModal={setShowHowUsageCalculatedModal}
        showEditUsageForm={() => setShowEditTariffModal(true)}
      />
    </div>
  );
};

export default Annual;
